import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import LoadingOverlay from 'react-loading-overlay'
import PropagateLoader from 'react-spinners/PropagateLoader'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
}

@withRouter
@connect(({ user }) => ({ user }))
class Layout extends React.PureComponent {
  previousPath = ''

  state = {
    isActive: false,
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname },
    } = this.props
    const {
      location: { pathname: prevPathname },
    } = prevProps
    if (pathname !== prevPathname) {
      window.scrollTo(0, 0)
      this.setState({ isActive: false })
    }
  }

  ShowLoader = isShow => {
    return (
      <LoadingOverlay
        active={true}
        styles={{ content: { margin: '35% auto' } }}
        spinner={
          <PropagateLoader
            css={`
              display: block;
              margin: 0 auto;
              border-color: red;
            `}
            size={15}
            color={'#00bfff'}
          />
        }
      ></LoadingOverlay>
    )
  }

  render() {
    const {
      children,
      location: { pathname, search },
      user,
    } = this.props

    const currentPath = pathname + search
    if (currentPath !== this.previousPath) {
      this.ShowLoader(true)
    }

    setTimeout(() => {
      this.ShowLoader(false)
      this.previousPath = currentPath
    }, 3000)

    // Layout Rendering
    const getLayout = () => {
      if (pathname === '/') {
        return 'public'
      }
      if (/^\/auth(?=\/|$)/i.test(pathname)) {
        return 'auth'
      }
      return 'main'
    }

    const Container = Layouts[getLayout()]
    const isUserAuthorized = user.authorized
    const isUserLoading = user.loading
    const isAuthLayout = getLayout() === 'auth'

    const BootstrappedLayout = () => {
      // show loader when user in check authorization process, not authorized yet and not on login pages
      if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
        return null
      }
      // redirect to login page if current is not login page and user not authorized
      if (
        !isAuthLayout &&
        !isUserAuthorized &&
        !window.location.toString().includes('/reportlink/')
      ) {
        return <Redirect to="/auth/login" />
      }
      // in other case render previously set layout
      return <Container>{children}</Container>
    }

    return (
      <Fragment>
        <Helmet titleTemplate="DNIF | Analytics Console" title="DNIF | Analytics Console" />
        {BootstrappedLayout()}
      </Fragment>
    )
  }
}

export default Layout
